/* eslint-disable no-prototype-builtins */
var XPortal = XPortal || {};
XPortal.Custom = (function () {
    var self = {};

    self.ShowErroMessageOnEmail = function (action, entity) {
        var state = XPortal.Store.GetBaseReduserState();
        if (!state.pageModels) return;
        if (!state.pageModels.hasOwnProperty(modelName)) return;
        var vmsges = state.pageModels[modelName].ValidationMessages = state.pageModels[modelName].ValidationMessages || {};
        vmsges[sttgs.fieldname] = vmsges[sttgs.fieldname] || {};
        vmsges[sttgs.fieldname].errors = [" data is not valid"];
        vmsges[sttgs.fieldname].success = false;
        var naction = Object.assign({}, action, { type: "VALIDATION_ERROR" });
        XPortal.Store.AppStore.dispatch(naction);
    };
    self.ValidateRegExp = function (data, rExp) {
        if (data && data.length > 0) {
            var re = new RegExp(rExp);
            var res = (data || "").match(re);
            return res;
        }
        return true;
    };
    self.ValidateEmailAddr = function (data) {
        if (!data || !data.trim()) return true;
        return self.ValidateRegExp(data, /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    };
    // {"title":"Email address format must be correct", "value":" XPortal.Custom.ValidateMultipleEmailAddr(value);", "serverSide":"" ,"description":"The format of email(s) specified in the field value must be correct; multiple emails must be separated by a comma or semicolon."}
    self.ValidateMultipleEmailAddr = function (data, splitRegEx) {
        if (!data || !data.trim()) return true;
        splitRegEx = splitRegEx ? splitRegEx : /[\,;]/;
        var itemsToValidate = data.split(splitRegEx);
        var result = true;
        for (var i = 0; i < itemsToValidate.length; i++) {
            var idata = itemsToValidate[i] || "";
            idata = idata.trim();
            result = self.ValidateEmailAddr(idata) && result;
        }
        return result;
    };

    self.EnsureVisitReferenceById = function (referenceId, alias, field, nodeid, editentity) {
        var re = /^.{3,}$/;
        var r = re.test(referenceId);//? "pending" : false;
        if (!r) return r;
        var data = { value: referenceId, entityAlias: alias, Field: field, NodeId: nodeid, redirects: [] };
        for (var f in editentity) data.redirects.push(f + "=" + editentity[f]);
        data = JSON.stringify(data);
        jQuery.ajax({
            url: XPortal.Utils.EnsureInProfile("/umbraco/Surface/CustomUi/EnsureVisitReferenceById"), type: 'POST', dataType: 'json', async: false, contentType: 'application/json; charset=utf-8', cache: false,
            headers: { "RequestVerificationToken": XPortal.Main.getAntiForgeryToken() },
            data: data,
            success: function (d) {
                r = d;
            }, error: function () {
                r = false;
            }
        });
        return r;
    };
    function getEntityToSend(nodeid) {
        var model = XPortal.Store.GetState().pageModels[XPortal.Store.GetModelByNodeId(nodeid)];
        var eEntity = (model || {}).entity;
        if (!eEntity || !eEntity.UniqueId) return {};
        var sEntity = (XPortal.Store.GetEditEntityToSave() || []).find(e => e.UniqueId === eEntity.UniqueId);
        if (!sEntity || !sEntity.Fields) return {};
        var r = {};
        for (var f in eEntity) {
            if (f === f.toLowerCase() && eEntity[f]) {
                var field = sEntity.Fields.find(x => x.Field.toLowerCase() === f);
                if (field && field.Data)
                    r[f] = field.Data;
            }
        }
        return r;
    };
    self.FindDataByReferenceId = function (data, el) {//validation from control
        var xform = $(el).closest(".detail-page").find(".edit-form");
        var efrmparams = XPortal.EditForm.EditFormParameters(xform);
        var sttgs = XPortal.Main.GetSettingsFor(el);
        var entity = getEntityToSend(efrmparams.NodeId);
        var data = self.EnsureVisitReferenceById(data, (efrmparams || { Alias: null }).Alias, sttgs.fieldname, (efrmparams || {}).NodeId, entity, ["location", ""]);
        if ((data || {}).NavigateTo) {
            if (window.location.href.indexOf(data.Item.UniqueId.toLowerCase()) < 0)
                window.location.href = (data || {}).NavigateTo;
        }
        return true;
    };
    self.ValidateLength = function (data, maxlength, minlength) {
        if (data && maxlength > 0)
            return data.length <= maxlength;
        if (minlength > 0)
            return (data || "").length >= minlength;
        return true;
    };
    //{"title":"Must contain only number", "value":" XPortal.Custom.ValidateOnlyNumbers(value);", "serverSide":"ValidateOnlyNumbers", "description":"The field value must contain only numbers [0-9]."}
    self.ValidateOnlyNumbers = function (data) {
        if (!data || !data.trim()) return true;
        return /^[0-9]*$/.test(data);
    };
    //{"title":"Must contain only letters", "value":" XPortal.Custom.ValidateOnlyLetters(value);", "serverSide":"ValidateOnlyLetters", "description":"The field value must contain only letters [a-z, A-Z]."}
    self.ValidateOnlyLetters = function (data) {
        if (!data || !data.trim()) return true;
        var r = /^[\p{L}]*$/u;
        return r.test(data);

    };
    //{"title":"Must contain only Latin letters", "value":" XPortal.Custom.ValidateOnlyLatinLetters(value);", "serverSide":"ValidateOnlyLatinLetters", "description":"The field value must contain only Latin letters [a-z, A-Z]."}
    self.ValidateOnlyLatinLetters = function (data) {
        if (!data || !data.trim()) return true;
        return /^[a-zA-Z']*$/.test(data);
    };
    //{"title":"Must not contain special characters", "value":" XPortal.Custom.ValidateNoSpecialSymbols(value);", "serverSide":"ValidateNoSpecialSymbols", "description":"The field value must not contain any special characters: ~`!@#$%^&*()-_+={}[]|\\;:\"<>,./?"}
    self.ValidateNoSpecialSymbols = function (data) {
        if (!data || !data.trim()) return true;
        var r = /^[\p{L}\p{N}]*$/u;
        return r.test(data);
    };
    // {"title":"Must be a strong password", "value":" XPortal.Custom.ValidatePasswordWithNumbers(value);", "serverSide":"ValidatePasswordWithNumbers", "description":"The field value must contain a minimum of 10 characters, with at least one letter of  lower case [a-z], one letter of upper case [A-Z], and one numeric character [0-9]."}
    self.ValidatePasswordWithNumbers = function (data) {
        if (!data || !data.trim()) return true;
        return /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{10,}$/.test(data);
    };
    // {"title":"Must be a very strong password", "value":" XPortal.Custom.Min8CharsOneLetterLUOneNumOneSpec(value);", "serverSide":"Min8CharsOneLetterLUOneNumOneSpec", "description":"The field value must contain a minimum of 10 characters, with at least one letter of  lower case [a-z], with at least one letter of upper case [A-Z], one numeric character [0-9], and one special character: ~`!@#$%^&*()-_+={}[]|\\;:\"<>,./?"}
    self.Min8CharsOneLetterLUOneNumOneSpec = function (data) {
        if (!data || !data.trim()) return true;
        return /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{10,}$/.test(data);
    };
    self.prevEResults = {};
    self.prevLResults = {};
    // {"title":"Portal member email must be unique", "value":" XPortal.Custom.ValidateMemberEmailAddrUniqueness.call(this, value, modelName);", "serverSide":"ValidateMemberEmailAddrUniqueness", "description":"Check that e-mail address doesn't registered yet for any existing member"}    
    self.ValidateMemberEmailAddrUniqueness = function (data, modelName) {
        if (!data || !data.trim()) return true;
        if (!modelName || !modelName.length) return false;
        const model = XPortal.Store.GetModelByName(modelName);
        const uniqueId = model.entity.UniqueId;
        const pres = self.prevEResults[modelName] || { res: false, prev: false, i: 0 };
        if (!pres.prev) self.prevEResults[modelName] = pres;
        if (pres.prev == data) return pres.res;
        pres.prev = data;
        return executeServerValidationCall(pres, { uniqueId, data, type: 0 });
    };
    // {"title":"Portal member login must be unique", "value":" XPortal.Custom.ValidateMemberLoginUniqueness.call(this, value, modelName);", "serverSide":"ValidateMemberLoginUniqueness", "description":"Check that login doesn't registered yet for any existing member"}
    self.ValidateMemberLoginUniqueness = function (data, modelName) {
        if (!data || !data.trim()) return true;
        if (!modelName || !modelName.length) return false;
        const model = XPortal.Store.GetModelByName(modelName);
        const uniqueId = model.entity.UniqueId;
        const pres = self.prevLResults[modelName] || { res: false, prev: false, i: 0 };
        if (!pres.prev) self.prevLResults[modelName] = pres;
        if (pres.prev == data) return pres.res;
        pres.prev = data;
        return executeServerValidationCall(pres, { uniqueId, data, type: 0 });
    };
    // {"title":"Required only in case when specified other field data is empty", "value":" XPortal.Custom.RequiredIfOtherEmpty('anotherFieldName', value, modelName);", "serverSide":"", "description":"Check that field contains data only in case when other field data is empty"}
    self.RequiredIfOtherEmpty = function (otherFieldName, data, modelName) {
        if (data && data.trim()) return true;
        if (!otherFieldName || !otherFieldName.length) return true;
        if (!modelName || !modelName.length) return false;
        const model = XPortal.Store.GetModelByName(modelName);
        const odata = XPortal.Template.GetObjPropValueByName(model.entity, otherFieldName);
        if (!odata) return false;
        if (_.isString(odata) && !odata.trim()) return fasle;
        return true;
    };
    // {"title":"Error only in case when specified other [field] data is equal [value]", "value":" XPortal.Custom.IfOtherEquals('anotherFieldName', value, modelName);", "serverSide":"", "description":"Check that field contains same data with other field data and raise error if so"}
    self.IfOtherEquals = function (otherFieldName, data, modelName, shouldBe) {
        if (data && data.trim()) return true;
        if (!otherFieldName || !otherFieldName.length) return true;
        if (!modelName || !modelName.length) return false;
        const model = XPortal.Store.GetModelByName(modelName);
        const odata = XPortal.Template.GetObjPropValueByName(model.entity, otherFieldName);
        const res = data == odata;
        if (!shouldBe) return !res;
        return res;
    };
    // {"title":"Error only in case when specified other [fields] data [are equal]", "value":" XPortal.Custom.IfOthersAreEquals('anotherFieldName1', 'anotherFieldName2', modelName);", "serverSide":"", "description":"Check that fields contain same data and raise error if so"}
    self.IfOthersAreEquals = function (otherFieldName1, otherFieldName2, modelName, shouldBe) {
        if (data && data.trim()) return true;
        if (!otherFieldName1 || !otherFieldName1.length) return true;
        if (!otherFieldName2 || !otherFieldName2.length) return true;
        if (!modelName || !modelName.length) return false;
        const model = XPortal.Store.GetModelByName(modelName);
        const odata = XPortal.Template.GetObjPropValueByName(model.entity, otherFieldName1);
        const odata2 = XPortal.Template.GetObjPropValueByName(model.entity, otherFieldName2);
        const res = odata == odata2;
        if (!shouldBe) return !res;
        return res;
    };
    function executeServerValidationCall(contextObj, data) {
        $.ajax({
            url: XPortal.Utils.EnsureInProfile("/umbraco/Surface/CustomUi/EnsurePortalDataExists"),
            type: 'POST',
            dataType: 'json',
            async: false,
            contentType: 'application/json; charset=utf-8',
            cache: false,
            headers: { "RequestVerificationToken": XPortal.Main.getAntiForgeryToken() },
            data: JSON.stringify(data),
            success: function (d) {
                contextObj.res = !d.IsExists;
            },
            error: function () {
                contextObj.res = false;
            }
        });
        return contextObj.res;
    };

    return self;
}());